import React, {
  Fragment,
  useContext,
  useEffect,
  useState,
  useRef,
} from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Autocomplete from "@mui/material/Autocomplete";
import { AlertContext } from "../../../context/AlertContext";
import { ConfiguracionContext } from "../../../context/ConfiguracionContext";
import Fab from "@mui/material/Fab";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import { Link, Redirect } from "react-router-dom";
import Spinner from "../Spinner";
import { AuthContext } from "../../../context/AuthContext";
import { Checkbox } from "primereact/checkbox";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import "../../../assets/css/DataTableDemo.css";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "../../../assets/css/PrimeGrid.css";
import "../../../assets/css/CierreDialog.css";
import { Tag } from "primereact/tag";
import ButtonMui from "@mui/material/Button";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import { Toast } from "primereact/toast";
import { Dialog } from "primereact/dialog";
import { Calendar } from "primereact/calendar";
import { addLocale, locale } from "primereact/api";
import hcOffcanvasNav from "hc-offcanvas-nav";
import $ from "jquery";
import { saveAs } from "file-saver";
import { Navigate, useNavigate } from "react-router-dom";
import Barra from "../Barra";
import { ThemeProvider } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import EventBusyOutlinedIcon from "@mui/icons-material/EventBusyOutlined";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import PictureAsPdfOutlinedIcon from "@mui/icons-material/PictureAsPdfOutlined";
import { getBrand, createBrandTheme } from "../../../theme/brand";
import PantallaHeader from "../common/PantallaHeader";

export default function Feriados(props) {
  const [globalFilter, setGlobalFilter] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);

  const exportColumns = [
    { title: "ID", dataKey: "id" },
    { title: "Fecha", dataKey: "fecha" },
  ];

  const [feriado, guardarFeriado] = useState(null);
  const [visible, setVisible] = useState(false);
  const toast = useRef(null);
  const toastWarm = useRef(null);
  const [date, setDate] = useState(null);
  let navigate = useNavigate();

  let today = new Date();
  let month = today.getMonth();
  let year = today.getFullYear();
  let prevMonth = month === 0 ? 11 : month - 1;
  let prevYear = prevMonth === 11 ? year - 1 : year;
  let nextMonth = month === 11 ? 0 : month + 1;
  let nextYear = nextMonth === 0 ? year + 1 : year;

  locale("es");

  let minDate = new Date();
  minDate.setDate(1);
  minDate.setMonth(0);
  minDate.setFullYear(year);

  let maxDate = new Date();
  maxDate.setDate(31);
  maxDate.setMonth(11);
  maxDate.setFullYear(year);

  addLocale("es", {
    firstDayOfWeek: 1,
    dayNames: [
      "domingo",
      "lunes",
      "martes",
      "miércoles",
      "jueves",
      "viernes",
      "sábado",
    ],
    dayNamesShort: ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"],
    dayNamesMin: ["D", "L", "M", "X", "J", "V", "S"],
    monthNames: [
      "enero",
      "febrero",
      "marzo",
      "abril",
      "mayo",
      "junio",
      "julio",
      "agosto",
      "septiembre",
      "octubre",
      "noviembre",
      "diciembre",
    ],
    monthNamesShort: [
      "ene",
      "feb",
      "mar",
      "abr",
      "may",
      "jun",
      "jul",
      "ago",
      "sep",
      "oct",
      "nov",
      "dic",
    ],
    today: "Hoy",
    clear: "Claro",
  });

  //Context

  const alertContext = useContext(AlertContext);
  const { mensajeAlerta } = alertContext;

  const authContext = useContext(AuthContext);
  const { state, usuarioAutenticado } = authContext;

  const configuracionContext = useContext(ConfiguracionContext);
  const {
    statusAcceso,
    configuracion,
    feriados,
    obtenerFeriados,
    obtenerAcceso,
    actualizarFeriados,
    eliminarFeriado,
  } = configuracionContext;

  const theme = createBrandTheme(getBrand(configuracion));

  useEffect(() => {
    if (state.usuario) {
      obtenerAcceso({ usuarioId: state.usuario.id, layout: "Feriados" });
    }
    obtenerFeriados({ year });
  }, [state.id]);

  setTimeout(() => {
    if (statusAcceso === 400) {
      accesoDenegado();
    }
  }, 3000);

  const deleteClick = (e) => {
    if (selectedRow) {
      toastWarm.current.show({
        severity: "warn",
        sticky: true,
        content: (
          <div
            className="p-flex p-flex-column"
            style={{ flex: "1", marginLeft: "1em" }}
          >
            <div className="p-text-center">
              <i
                className="pi pi-exclamation-triangle"
                style={{ fontSize: "3rem" }}
              ></i>
              <h4>{`Confirma eliminar feriado ${selectedRow.fecha} ?`}</h4>
            </div>
            <div className="p-grid p-fluid">
              <div className="p-col-6">
                <Button
                  type="button"
                  label="Si"
                  className="p-button-success"
                  onClick={(e) => opcionSiEliminar(selectedRow)}
                />
              </div>
              <div className="p-col-6">
                <Button
                  type="button"
                  label="No"
                  className="p-button-danger"
                  style={{ marginTop: "1em" }}
                  onClick={opcionNo}
                />
              </div>
            </div>
          </div>
        ),
      });
    } else {
      toast.current.show({
        severity: "info",
        summary: "Eliminar",
        detail: "Debe seleccionar una feriado.",
        life: 3000,
      });
    }
  };

  function opcionSiEliminar(selectedRow) {
    eliminarFeriado({ selectedRow });
    setTimeout(() => {
      obtenerFeriados({ year });
    }, 2000);
    toastWarm.current.clear();
    setSelectedRow(null);
  }

  function opcionNo() {
    toastWarm.current.clear();
    setSelectedRow(null);
  }

  const addClick = (e) => {
    //navigate(`/feriado/0`);
    setVisible(true);
    setSelectedRow(null);
    setDate(null);
  };

  const exitClick = (e) => {
    navigate(`/`);
  };

  const onHide = (e) => {
    setVisible(false);
  };

  const aceptarClick = (e) => {
    e.preventDefault();
    //Validar
    if (!date || date === undefined || date === null || date.length === 0) {
      mensajeAlerta("Feriados", "Una fecha es necesaria !.", "error");
      return;
    }

    // Llamar al context
    actualizarFeriados({ feriados, date });

    onHide();
    setSelectedRow(null);
    setTimeout(() => {
      obtenerFeriados({ year });
    }, 2000);
    //exitClick();
  };

  const accesoDenegado = () => {
    mensajeAlerta(
      "Accesos",
      "No tiene permiso para acceder a esta pantalla !.",
      "error"
    );
    exitClick();
    return;
  };

  const idTemplate = (rowData) => {
    return (
      <Fragment>
        <span className="p-column-title">ID</span>
        {rowData.id}
      </Fragment>
    );
  };

  const fechaTemplate = (rowData) => {
    return (
      <Fragment>
        <span className="p-column-title">Fecha</span>
        {rowData.fecha}
      </Fragment>
    );
  };

  const exportPdf = () => {
    import("jspdf").then((jsPDF) => {
      import("jspdf-autotable").then(() => {
        const doc = new jsPDF.default(0, 0);
        doc.autoTable(exportColumns, feriados);
        doc.save("feriados.pdf");
      });
    });
  };

  const exportExcel = () => {
    import("xlsx").then((xlsx) => {
      const worksheet = xlsx.utils.json_to_sheet(feriados);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      saveAsExcelFile(excelBuffer, "feriados");
    });
  };

  const saveAsExcelFile = (buffer, fileName) => {
    import("file-saver").then((FileSaver) => {
      let EXCEL_TYPE =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      let EXCEL_EXTENSION = ".xlsx";
      const data = new Blob([buffer], {
        type: EXCEL_TYPE,
      });
      saveAs(
        data,
        fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
      );
    });
  };

  const renderHeader = () => {
    return (
      <div>
        <Tag value="Feriados"></Tag>
      </div>
    );
  };

  const renderFooter = () => {
    return (
      <div>
        <ButtonMui
          onClick={aceptarClick}
          color="primary"
          type="button"
          fullWidth
          variant="contained"
          startIcon={<CheckIcon />}
        >
          Aceptar
        </ButtonMui>
        <ButtonMui
          onClick={onHide}
          color="secondary"
          type="button"
          fullWidth
          variant="contained"
          startIcon={<CloseIcon />}
          autoFocus
        >
          Cancelar
        </ButtonMui>
      </div>
    );
  };

  //console.log(date);
  //console.log(state);

  return (
    <Fragment>
      <Barra />
      <Toast ref={toast} />
      <Toast ref={toastWarm} position="top-right" />
      {statusAcceso === 0 || statusAcceso === 400 ? <Spinner /> : null}
      {statusAcceso === 200 ? (
        <Fragment>
          {feriados ? (
            <ThemeProvider theme={theme}>
              <Box sx={{ px: { xs: 1, sm: 2 }, pb: 3 }}>
                <PantallaHeader
                  icono={<EventBusyOutlinedIcon />}
                  titulo="Feriados"
                  count={feriados ? feriados.length : null}
                  onBuscar={(v) => setGlobalFilter(v)}
                  acciones={[
                    {
                      label: "Nuevo",
                      variant: "contained",
                      icon: <AddIcon />,
                      onClick: addClick,
                    },
                    {
                      label: "Eliminar",
                      color: "error",
                      icon: <DeleteOutlineIcon />,
                      onClick: deleteClick,
                    },
                    {
                      label: "Excel",
                      color: "success",
                      icon: <FileDownloadOutlinedIcon />,
                      onClick: exportExcel,
                    },
                    {
                      label: "PDF",
                      color: "warning",
                      icon: <PictureAsPdfOutlinedIcon />,
                      onClick: exportPdf,
                    },
                    {
                      label: "Cerrar",
                      variant: "text",
                      color: "inherit",
                      icon: <CloseIcon />,
                      onClick: exitClick,
                    },
                  ]}
                />
                <Paper
                  elevation={0}
                  sx={{
                    borderRadius: 2,
                    overflow: "hidden",
                    "& .p-datatable-wrapper": { overflowX: "auto" },
                  }}
                >
                    <DataTable
                      value={feriados}
                      selection={selectedRow}
                      onSelectionChange={(e) => setSelectedRow(e.value)}
                      selectionMode="single"
                      dataKey="id"
                      className="p-datatable-sm p-datatable-striped p-datatable-responsive-demo mito-grid"
                      style={{ fontSize: "small" }}
                      globalFilter={globalFilter}
                      emptyMessage="No hay datos."
                      paginator
                      paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                      currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords}"
                      rows={10}
                      rowsPerPageOptions={[10, 20, 50]}
                      //paginatorLeft={paginatorLeft}
                      //paginatorRight={paginatorRight}
                    >
                      <Column
                        field="id"
                        header="ID"
                        body={idTemplate}
                        sortable
                      ></Column>
                      <Column
                        field="fecha"
                        header="Fecha"
                        body={fechaTemplate}
                        sortable
                      ></Column>
                    </DataTable>
                </Paper>
              <Dialog
                header={renderHeader()}
                className="cierre-dialog"
                visible={visible}
                closable={false}
                footer={renderFooter()}
                breakpoints={{ "960px": "75vw" }}
                style={{ width: "50vw", paddingBottom: "0" }}
                position="center"
              >
                <Grid container spacing={3} style={{ marginTop: "1vw" }}>
                  <Grid item xs={12} md={12} style={{ marginLeft: "1vw" }}>
                    <div className="p-field p-col-12 p-md-4">
                      <Calendar
                        id="multiple"
                        value={date}
                        onChange={(e) => setDate(e.value)}
                        //minDate={minDate}
                        //maxDate={maxDate}
                        selectionMode="multiple"
                        style={{width: "80%"}}
                        inline
                      />
                    </div>
                  </Grid>
                </Grid>
              </Dialog>
              </Box>
            </ThemeProvider>
          ) : (
            <Spinner />
          )}
          <Grid item xs={12} sm={12}></Grid>
        </Fragment>
      ) : null}
    </Fragment>
  );
}

/* class="MuiDataGrid-cell MuiDataGrid-cellLeft" */
